import { create } from 'zustand';

/** "Compare with original" toggle: when on, the case page also asks the reference bridge (original Xspouse engine). */
interface ReferenceStore {
  enabled: boolean;
  toggle(): void;
  setEnabled(enabled: boolean): void;
}

export const useReferenceStore = create<ReferenceStore>((set) => ({
  enabled: false,
  toggle: () => set((s) => ({ enabled: !s.enabled })),
  setEnabled: (enabled) => set({ enabled }),
}));
